import { INTEGRATION_LOGOS_CDN } from "@/lib/cdn";

/** CDN URL for an integration's logo. Missing logos 404 — render sites hide
 *  the coin via onError rather than guessing at a curated slug list. */
export function integrationLogoUrl(slug: string): string {
  return `${INTEGRATION_LOGOS_CDN}/${encodeURIComponent(slug)}.svg`;
}
